export const VALIDATING_CUSTOMER = 'VALIDATING_CUSTOMER';
export const SET_CUSTOMER = 'SET_CUSTOMER';

export const UPDATE_USER = 'UPDATE_USER';

export const LOAD_TODAYHAPPINESS = 'LOAD_TODAYHAPPINESS';
export const SET_MYHAPPINESS = 'SET_MYHAPPINESS';
export const SET_EMPLOYEE_HAPPINESS = 'SET_EMPLOYEE_HAPPINESS';
export const UPDATE_EMPLOYEES = 'UPDATE_EMPLOYEES';
export const UPDATE_QUOTES = 'UPDATE_QUOTES';
export const SET_OVERLAY = 'SET_OVERLAY';
export const LOAD_GRAPH_DATA = 'LOAD_GRAPH_DATA';
export const SET_SHORTCUTS = "SET_SHORTCUTS";
export const SET_ACTIVE_SHORTCUT = "SET_ACTIVE_SHORTCUT";

export const SET_WEATHER = "SET_WEATHER";

export const DATA_ADDED = "DATA_ADDED";
export const DATA_MODIFIED = "DATA_MODIFIED";
export const DATA_REMOVED = "DATA_REMOVED";
export const ADD_LISTENER = "ADD_LISTENER";
export const TIMER = "TIMER";

export const SET_LOGGEDIN_USER_ID = 'SET_LOGGEDIN_USER_ID';
export const SET_CURRENT_CUSTOMER_ID = 'SET_CURRENT_CUSTOMER_ID';
